import { render, staticRenderFns } from "./CollegeMajorCreate.vue?vue&type=template&id=fabed184&scoped=true&"
import script from "./CollegeMajorCreate.vue?vue&type=script&lang=js&"
export * from "./CollegeMajorCreate.vue?vue&type=script&lang=js&"
import style0 from "./CollegeMajorCreate.vue?vue&type=style&index=0&id=fabed184&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabed184",
  null
  
)

export default component.exports